import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { authPhaseAtom } from '../stores/auth/atoms';
import { DaemonSessionOverlay } from './DaemonSessionOverlay';

export { DaemonSessionOverlay } from './DaemonSessionOverlay';

// Desktop auth view: renders the projected phase, drives sign-in (sdk ADR-010).
export function DaemonSessionGate() {
  const phase = useAtomValue(authPhaseAtom);
  const [pending, setPending] = useState(false);
  const [signInError, setSignInError] = useState<string | null>(null);

  const handleSignIn = async () => {
    setPending(true);
    setSignInError(null);
    try {
      const api = (
        window as unknown as { electronAPI?: { invoke: (c: string) => Promise<unknown> } }
      ).electronAPI;
      if (!api || typeof api.invoke !== 'function') {
        throw new Error(
          'window.electronAPI is undefined — the Electron preload bridge did not load',
        );
      }
      await api.invoke('auth:signIn');
    } catch (err) {
      const e = err as Error;
      if (e.name === 'AgentOfflineError') {
        setSignInError('ShogunChop agent is offline. Check the menubar.');
      } else {
        setSignInError(e.message);
      }
    } finally {
      setPending(false);
    }
  };

  return (
    <DaemonSessionOverlay
      phase={phase}
      pending={pending}
      signInError={signInError}
      onSignIn={() => {
        void handleSignIn();
      }}
    />
  );
}
